"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _Icon = _interopRequireDefault(require("./Icon"));

var _jsxRuntime = require("react/jsx-runtime");

var MenuCommand = function MenuCommand(props) {
  var menuItem = /*#__PURE__*/(0, _jsxRuntime.jsx)(_core.MenuItem, {
    onClick: props.onClick,
    disabled: props.disabled,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "flex-container",
      children: [props.icon && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
        icon: props.icon
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        children: props.label
      })]
    })
  });

  if (!props.disabled) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: props.BOCommand ? 'background-bo' : '',
      style: {
        outline: 0
      },
      children: menuItem
    });
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: props.BOCommand ? 'background-bo' : '',
    style: {
      outline: 0
    },
    children: props.disabled ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_core.Tooltip, {
      title: props.disabledMessage,
      placement: "left",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        children: menuItem
      })
    }) : {
      menuItem: menuItem
    }
  });
};

MenuCommand.propTypes = {
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func.isRequired,
  label: _propTypes.default.object.isRequired,
  disabledMessage: _propTypes.default.string,
  icon: _propTypes.default.string,
  BOCommand: _propTypes.default.bool
};
MenuCommand.defaultProps = {
  disabled: false,
  BOCommand: false,
  disabledMessage: ''
};
var _default = MenuCommand;
exports.default = _default;
//# sourceMappingURL=MenuCommand.js.map